import type { ReactNode } from 'react';

import type { TParagraphElement } from '@shared/dream-components';
import { ParagraphSerializer } from '@shared/dream-components';

import usePodcastMergeTagProcessor from './hooks/usePodcastMergeTagProcessor';
import useProductMergeTagProcessor from './hooks/useProductMergeTagProcessor';

interface Props {
  node: TParagraphElement;
  children: ReactNode | ReactNode[];
}

const Paragraph = ({ node, children }: Props) => {
  const { children: childrenToRenderProduct, node: nodeToRenderProduct } = useProductMergeTagProcessor({
    node,
    children,
  });
  const { children: childrenToRender } = usePodcastMergeTagProcessor({
    node: nodeToRenderProduct,
    children: childrenToRenderProduct,
  });

  return <ParagraphSerializer element={node}>{childrenToRender}</ParagraphSerializer>;
};

export default Paragraph;
